import React, { memo } from 'react';

import { OverviewAttendanceWidget } from './OverviewAttendanceWidget';
import { OverviewPerformanceWidget } from './OverviewPerformanceWidget';
import { OverviewMoneyWidget } from './OverviewMoneyWidget';
import { IOverviewWidgetProps } from './types';
import { SummaryGrid } from './overview.styled';

/**
 * OverviewSummaryGrid (Requirement 1) — composes the three consolidated health
 * widgets (attendance, performance, money) in a responsive three-up grid that
 * collapses to a single column on narrow viewports.
 *
 * It is purely a layout composition: each widget owns its own data hook and
 * three-state rendering, so the grid just forwards `groupId` and the shared
 * `onNavigate` callback down to all three. It deliberately does NOT render the
 * HeaderBar identity fields or KPI-strip values — that flat key-value list is
 * the anti-goal called out in Requirement 2.5; only the three health widgets
 * live here.
 */
export const OverviewSummaryGrid = memo(
  ({ groupId, onNavigate }: IOverviewWidgetProps) => (
    <SummaryGrid>
      <OverviewAttendanceWidget groupId={groupId} onNavigate={onNavigate} />
      <OverviewPerformanceWidget groupId={groupId} onNavigate={onNavigate} />
      <OverviewMoneyWidget groupId={groupId} onNavigate={onNavigate} />
    </SummaryGrid>
  ),
);
